export default __webpack_public_path__ + "static/media/reward-program-points.7f74c912.svg";